import { init, browserTracingIntegration } from '@sentry/react'
import { TransactionEvent, EventHint, SpanJSON } from '@sentry/core'

export const beforeSendTransaction = (
  event: TransactionEvent,
  _hint: EventHint,
) => {
  const skipSpanFilter = process.env.REACT_APP_SENTRY_SKIP_SPAN_FILTER
    ? process.env.REACT_APP_SENTRY_SKIP_SPAN_FILTER.split(',')
    : []

  if (skipSpanFilter.length === 0) {
    return event
  }

  const filteredSpans =
    event?.spans?.filter((span: SpanJSON) => {
      const spanHost = String(span?.data?.['server.address'] || '')
      return !skipSpanFilter.some((substring) => spanHost?.includes(substring))
    }) ?? []

  if (filteredSpans.length !== event?.spans?.length) {
    return { ...event, spans: filteredSpans }
  }
  return event
}

export const initSentry = () => {
  init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_STAGE,
    enabled: process.env.REACT_APP_ENABLE_SENTRY === 'true',
    // @ts-ignore
    beforeSendTransaction,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: Number(
      process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.4',
    ),
    tracePropagationTargets: (
      process.env.REACT_APP_SENTRY_TRACE_PROPAGATION_TARGETS || ''
    ).split(','),
  })
}

initSentry()
